
import 'preact/debug';
import App from "./components/app";

import "bootstrap/dist/js/bootstrap";
import "./scss/app.scss";
import moment from "moment";
import "moment/dist/locale/fr";

moment.locale("fr");


    // get all canvas that were not initialized


export default App;
